import { HStack, Text, Button, Box, Center } from '@chakra-ui/react';
import Content from '~/containers/Content';

// 產生回收驗證碼
export default function CheckBar({
  totalAmount,
  title,
  onCheckout,
}: {
  totalAmount: number;
  title: string;
  onCheckout: () => void;
}) {
  return (
    <Box as="section" position="sticky" bottom={0} zIndex={100} opacity={totalAmount ? '1' : '0.6'}>
      <Content m="auto" bg="secondary" py={2} px={4}>
        <HStack justify="space-between">
          <Center borderRadius="5px" bg="#513F24" w="2rem" h="2rem">
            <Text color="white" fontSize="md" fontWeight="bold">
              {totalAmount}
            </Text>
          </Center>
          <Button
            variant="unstyled"
            color="white"
            onClick={() => {
              totalAmount && onCheckout();
            }}
            fontWeight="bold"
            letterSpacing={1}
          >
            {title}
          </Button>
        </HStack>
      </Content>
    </Box>
  );
}
